// import Table from './components/table';


// echart-component
// import EchartComponent from './components/echart-component';
// const components = {
//     echartComponent: EchartComponent,
// };

// select
import { Select, Option, OptionGroup } from './components/select';
const components = {
    iviewSelect: Select,
    iviewOption: Option,
    iviewOptionGroup: OptionGroup,
};

const install = function (Vue) {
    if (install.installed) return;
    Object.keys(components).forEach(key => {
        Vue.component(key, components[key]);
    });
};
// auto install
if (typeof window !== 'undefined' && window.Vue) {
    console.log('install iview4Select');
    install(window.Vue);
}



// WEBPACK FOOTER //
// ./src/indexComponent.js